export const UPDATE_CONTAINER = 'UPDATE_CONTAINER';

export const updateContainer = (containerRect) => {
  return {
    type: UPDATE_CONTAINER,
    payload: { containerRect },
  };
};
